import React from 'react'

const HorseRacing = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 23 25' version='1.1'>
      <title>Horseracing</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-620.000000, -527.000000)' fill={fill} fillRule='nonzero'>
          <g id='onboarding/sport-copy-23' transform='translate(579.000000, 503.000000)'>
            <g id='icons/16/sports/horse-racing/jockey' transform='translate(41.000000, 24.089286)'>
              <path
                d='M12.15,0 C13.0778384,0 13.83,0.75216162 13.83,1.68 C13.83,2.60783838 13.0778384,3.36 12.15,3.36 C11.2221616,3.36 10.47,2.60783838 10.47,1.68 C10.47,0.75216162 11.2221616,0 12.15,0 Z M7.875,12.375 L5.625,10.125 L0.75,10.125 L5.43,14.82 L7.875,12.375 Z M18.9,13.875 L21.9,16.875 L23.025,16.125 L20.4,8.625 L19.545,9.915 C17.773937,9.4271754 15.9290932,9.26454453 14.1,9.435 L12.165,7.5 L12.165,5.83287595 C12.165,5.69981289 12.1119606,5.57223833 12.0176242,5.47839582 L9.3,2.775 L9.3,2.775 C9.00327948,2.48732506 8.53172052,2.48732506 8.235,2.775 L5.025,6 L7.65,8.625 L9.9,6.375 L9.9,8.02789322 C9.9,8.16050146 9.95267842,8.28767842 10.0464466,8.38144661 L11.4,9.735 L11.4,9.735 C10.455,9.915 9.9,10.08 9.9,10.08 L8.775,10.08 L10.5,11.85 C10.7858572,12.1416326 10.7858572,12.6083674 10.5,12.9 L7.68,15.72 L12.9,16.875 L17.97,20.625 L19.47,24 L21.525,24 L18.9,19.125 L15.525,15.75 C16.3290818,14.669952 17.5581802,13.9871196 18.9,13.875 Z'
                id='appearance'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default HorseRacing
